module.exports = __webpack_public_path__ + "img/1550837947.2bcc72a8.jpg";